module.exports = __webpack_public_path__ + "img/main_review_img_03.8d708d76.png";